var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.shouldShowUp),expression:"shouldShowUp"}],staticClass:"intro-tooltip",class:[_vm.widgetButtonPosition === 'right' ? 
    'intro-tooltip--left fade-in-right' : 
    'intro-tooltip--right fade-in-left']},[_vm._v("\n  "+_vm._s(_vm.message)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }